import { GUID, insertTextAtCursor } from 'core/utils';
import ParaModel from 'src/paraphraser/handlers/ParaModel';
import { setSignupModalState, toggleKeyboardAction } from 'src/_common/actions/commonActions';
import { openToastr } from 'src/_common/handlers/services';
import { ToggleKeyboardAction } from 'src/_common/models/redux/actions';
import { RootState } from 'src/_common/models/redux/store';
import { ThunkAction } from 'redux-thunk';
import CONSTANTS, { QUILL_SETTINGS, NON_PREMIUM_MODE_STRENGTH } from '../constants';
// import { openAlertDialog } from '@Common/handlers/services';
import Track from 'src/paraphraser/handlers/track';
import cyrilicData from 'public/jsonData/cyrilic_lookup.json';
import axios from 'axios';
import Logger from 'core/logger/logger';
import * as ActionTypes from '../models/actions';
import * as Actions from './paraModelActions';
import Stats from '../handlers/Stats';
// import { paraphraseArticle } from './userParaphrasedAction';
import { splitIntoSentences } from 'core/utils/sentenceSplitter';
import Paraphraser from '../handlers/paraphraser';
import { sentenceSplitter } from 'src/_common/handlers/api';
import Bugsnag from '@bugsnag/js';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { ABTestNames } from 'config/constants';

let QuillTimer: any = null;

export const setFthresh = (fthresh: number) => {
  Track.changedWordFlipperValue(fthresh, 'topControlBar', true, ParaModel.submissionID);
  QuillLocalStorage.getInstance().set('fthresh', `${fthresh}`);
  return Actions.changedWordFlipper(fthresh);
};

export const setModeStrength =
  (strength: number): ThunkAction<void, RootState, null, ActionTypes.SetStrength> =>
  (dispatch: any, getState: any) => {
    Track.togglePriority(
      strength,
      'topControlBar',
      getState()?.pphr?.strength,
      ParaModel.submissionID
    );
    if (strength !== undefined) {
      if (getState()?.user?.premium || NON_PREMIUM_MODE_STRENGTH.indexOf(strength) !== -1) {
        QuillLocalStorage.getInstance().set('prioritize', `${strength}`);
      }
      return dispatch(Actions.setStrength(strength));
    }
  };

export const setKeyboardToggleAction = (isOpen: boolean) => (dispatch: any, getState: any) => {
  const mode = getState()?.common?.platform || {};
  const isKeyboardOpen = getState()?.common?.isKeyboardOpen;
  if (!mode.isMobile) return;
  if (isOpen && !isKeyboardOpen) {
    // dispatch(setKeyboardToggle(true));
    dispatch(toggleKeyboardAction(isOpen));
    ParaModel.adjustMobileContainerheight(mode, isKeyboardOpen);
  } else if (!isOpen && isKeyboardOpen) {
    // dispatch(setKeyboardToggle(false));
    dispatch(toggleKeyboardAction(isOpen));
    ParaModel.moveToBreakPoint(getState()?.common?.platform, 1);
    ParaModel.moveToBaseScrollTopPos(getState()?.common?.platform);
  }
};

export const toggleOutputBoxEditabilityForMobile =
  (
    isEditable: boolean
  ): ThunkAction<void, RootState, null, ActionTypes.OutputBoxEditableForMobile> =>
  (dispatch: any, getState: any) => {
    const mode = getState()?.common?.platform || {};
    const isOutputBoxEditableForMobile = getState()?.pphr?.isOutputBoxEditableForMobile;

    if (!mode.isAndroid) return;
    if (!ParaModel.focusedParaphraser || ParaModel.paraphrasers.length === 0) return;
    let outputBox = document.getElementById('outputText');

    if (!outputBox) return;
    if (isEditable) {
      dispatch(Actions.setOutputBoxEditableForMobile(true));
      ParaModel.setFocusOnMobileOutputBox(isOutputBoxEditableForMobile, mode);
      return;
    }
    dispatch(Actions.setOutputBoxEditableForMobile(false));
  };

export type ResetStateActions =
  | ActionTypes.SetOutputParaphraserUpdater
  | ActionTypes.SetInputSentences
  | ActionTypes.SetFocusedInputParaphrase
  | ActionTypes.SetInputText
  | ActionTypes.ShowCharLimitMessage
  | ActionTypes.SetStrength;
export const resetStateActionCreator =
  (cb: any, onLogout: any): ThunkAction<void, RootState, null, ResetStateActions> =>
  (dispatch: any, getState: any) => {
    const undoStateReset = () => {
      Track.userClickedUndo(getState()?.pphr?.lastSubmission);
      ParaModel.paraphrasers = ParaModel.prevState_paraphrasers;

      dispatch(
        Actions.setLastParaphrasedText({
          inputText: getState()?.pphr?.lastSubmission,
          inputSentences: ParaModel.prevState_inputSentences as any,
        })
      );
      ParaModel.focusedParaphraser = ParaModel.prevState_focusedParaphraser;

      // need to be shifted to reducer with appropriate condition
      dispatch(
        Actions.setFocusedInputParaphrase({
          pID: (ParaModel.focusedParaphraser as any)?.pID,
          text: (ParaModel.focusedParaphraser as any)?.text,
          indent: (ParaModel.focusedParaphraser as any)?.indent,
        })
      );
      setTimeout(() => {
        if (cb) cb();
      }, 100);
    };
    // const textElem = document.getElementById('inputText');
    if (getState()?.pphr?.inputText) {
      ParaModel.textBeforeResetState = getState()?.pphr?.inputText;
      ParaModel.defaultStateFordetectCall();
      ParaModel.extraText = '';
    }

    if (ParaModel.paraphrasers.length !== 0) {
      ParaModel.prevState_paraphrasers = ParaModel.paraphrasers;
      ParaModel.prevState_inputSentences = getState()?.pphr?.inputSentences;
      ParaModel.prevState_focusedParaphraser = ParaModel.focusedParaphraser as object;
      ParaModel.originalSubmission = CONSTANTS.DEMO_DEFAULT;
      ParaModel.paraphrasers = [];
      ParaModel.focusedParaphraser = null;
      if (!onLogout) openToastr('Text Deleted.', 4000, undoStateReset, 'Undo');
    }
    // if (onLogout) dispatch(setFreezeWords([]));
    dispatch(Actions.userResettedParaphraseState());
    if (cb) cb();
  };

export const setFocusedParaphraser =
  (p: any): ThunkAction<void, RootState, null, ActionTypes.SetFocusedInputParaphrase> =>
  (dispatch: any, getState: any) => {
    if (p !== ParaModel.focusedParaphraser) {
      if (ParaModel.focusedParaphraser) {
        (ParaModel.focusedParaphraser as any).stopFocusTimer();
      }
      ParaModel.focusedParaphraser = p;

      //Call the compare Mode function if user change the focusedParaphraser
      if (
        getState()?.common?.isOpencompareModeDrawer &&
        ParaModel.focusedParaphraser &&
        // FireStore.getInstance().isPremiumUser()
        getState()?.user?.premium
      )
        (ParaModel.focusedParaphraser as any).compareModeOn();
      if (
        getState()?.common?.isOpencompareModeDrawer &&
        ParaModel.focusedParaphraser &&
        // !FireStore.getInstance().isPremiumUser()
        !getState()?.user?.premium
      )
        (ParaModel.focusedParaphraser as any).compareModeOnNonPremium();

      let focusedInputParaphraserList = ParaModel.setFocusedInputParaphraser(
        getState()?.pphr?.inputSentences?.sentenceList
      );
      if (focusedInputParaphraserList?.length === 1) {
        dispatch(Actions.setFocusedInputParaphrase(focusedInputParaphraserList[0]));
      }

      (ParaModel.focusedParaphraser as any).startFocusTimer();
      ParaModel.setScrollPosition(getState()?.common?.platform);
    }
  };

export const reQuillArticle =
  (
    sourceFn: 'redo' | 'redoWF'
  ): ThunkAction<
    void,
    RootState,
    null,
    | ActionTypes.SetOutputParaphraserUpdater
    | ActionTypes.SetStartedQuilling
    | ActionTypes.NumberOfCompletedParaphrases
    // | ActionTypes.ChangeLastSubmission
  > =>
  (dispatch: any, getState: any) => {
    /*
      Check if the variable promiseResolveWait variable contains
      the promise return by language detect call , if not then assisgn the promise 
      of language detect call to the variable
    */
    if (!ParaModel.promiseResolveWait && getState()?.user?.premium && false) {
      ParaModel.promiseResolveWait = ParaModel.callLanguageDetectApi(getState()?.pphr?.inputText);
    }

    //Check if the language detect prmoise is resolved or not
    Promise.all([ParaModel.promiseResolveWait])
      .then(() => {
        if (ParaModel.inputLanguage === 'es') ParaModel.outputBoxSpanishLangBanner = true;
        else ParaModel.outputBoxSpanishLangBanner = false;

        ParaModel.spanishLanguageFeedbackGood = false;
        ParaModel.spanishLanguageFeedbackBad = false;
        ParaModel.spanishLangBanner = false;

        if (getState()?.common?.maintenance?.isMaintenance) {
          ParaModel.showMaintenanceAlert();
          return;
        }

        if (getState()?.pphr?.startedQuilling) {
          // openToastr('Quilling underway...');
          clearTimeout(QuillTimer);
          QuillTimer = setTimeout(() => {
            dispatch(reQuillArticle(sourceFn));
          }, 1000);
          return;
        }

        const isRecaptchaShown = getState().common?.recaptcha?.isShown;
        if (isRecaptchaShown) {
          dispatch(Actions.setStartedQuilling(false));
          return;
        }

        /* const isAllParaphrasersLocked =
        ParaModel.paraphrasers.length && ParaModel.paraphrasers.every((p: any) => p.locked);
      if (isAllParaphrasersLocked && getState()?.pphr?.showRephrase) {
        openAlertDialog(
          true,
          'Unlock All Sentences',
          'Clicking the Rephrase button will unlock all locked sentences.',
          'Continue',
          ParaModel.unlockAllSentences.bind(ParaModel, () => {
            Track.unlockAllSentences('RequillConfirmationBox');
            dispatch(reQuillArticle());
            // dispatch(
            //   Actions.userChangedSentenceLockedStatus(ParaModel.getLockedParaphrasersLength())
            // );
          })
        );

        return;
      } */

        // let text = getState()?.pphr?.inputText?.trim();
        // let cyrillicFreeText = ParaModel.checkCyrillicCharacters(text);
        // if (text !== cyrillicFreeText) {
        //   dispatch(Actions.setInputText(cyrillicFreeText));
        // }

        /**
         * Adding toastr message when existing user clicks on paraphrase button with no text.
         */
        if (
          !getState()?.pphr?.inputText?.trim()?.length &&
          (+QuillLocalStorage.getInstance().get('submittedInputCount', '0') ||
            getState()?.user?.isAuthenticated)
        ) {
          openToastr('Enter some text to paraphrase');
          return;
        }

        if (
          (!getState()?.pphr?.showRephrase || ParaModel.paraphrasers.length === 0) &&
          !getState()?.user?.isAuthenticated
        ) {
          let modeQuills = JSON.parse(QuillLocalStorage.getInstance().get(`mode-quills`, '{}'));
          let numberofQuillsForMode = 0;

          if (
            modeQuills.date === new Date().getDate() &&
            modeQuills.month === new Date().getMonth() &&
            modeQuills.value
          ) {
            numberofQuillsForMode = modeQuills.value;
          }

          let AllowedNumberOfQuills = 5;

          if (numberofQuillsForMode >= AllowedNumberOfQuills) {
            dispatch(setSignupModalState(true));
            return;
          }
          QuillLocalStorage.getInstance()?.set(
            `mode-quills`,
            JSON.stringify({
              value: numberofQuillsForMode + 1,
              date: new Date().getDate(),
              month: new Date().getMonth(),
            })
          );
        }

        dispatch(Actions.setStartedQuilling(true));

        if (getState()?.pphr?.showRephrase && ParaModel.paraphrasers.length > 0) {
          /*  When user Click on the rephrase button and compare mode drawer is open , it show the progress bar in
          respective compare drawer mode */
          ParaModel.paraphrasers.forEach((p: any) => {
            p.loading = true;
            if (
              getState()?.common?.isOpencompareModeDrawer &&
              ParaModel.focusedParaphraser &&
              p.compareModeEdited
            )
              p.compareModeEdited[getState()?.pphr?.strength] = true;
            setTimeout(() => {
              p[sourceFn](
                {
                  finished: () => {
                    p.loading = false;
                    if (
                      getState()?.common?.isOpencompareModeDrawer &&
                      ParaModel.focusedParaphraser &&
                      p.compareModeEdited
                    )
                      p.compareModeEdited[getState()?.pphr?.strength] = false;

                    // Stats.updateStats();
                    dispatch(Actions.completedSentenceParaphrasing());
                    if (
                      getState()?.pphr?.numberOfCompletedParaphrases >=
                      ParaModel.paraphrasers.length
                    ) {
                      // dispatch(Actions.setStartedQuilling(false));
                      // Stats.updateStats();
                      ParaModel.batchDispatchCall(dispatch, null);
                      ParaModel.saveParaphraserData();
                    }
                  },
                },
                getState()?.pphr?.strength,
                // ParaModel?.focusedParaphraser?.fthresh
                getState()?.pphr?.wordFlipperValue
              );
            });
          });
        } else {
          ParaModel.articleSubmissionTime = Date.now();
          ParaModel.loadDictionaryData();
          let text = getState()?.pphr?.inputText?.trim();
          let cyrillicFreeText = ParaModel.checkCyrillicCharacters(text);
          if (text !== cyrillicFreeText) {
            dispatch(Actions.setCyrillicFreeText(cyrillicFreeText));
          }
          dispatch(makeParaphrases(getState()?.pphr?.lastSubmission));
        }
      })
      .catch((error) => {
        dispatch(Actions.setStartedQuilling(false));
      });
  };
export const makeParaphrases =
  (
    input: any
  ): ThunkAction<
    void,
    RootState,
    null,
    ActionTypes.SetOutputParaphraserUpdater | ActionTypes.NumberOfCompletedParaphrases
  > =>
  async (dispatch: any, getState: any) => {
    //why this is done
    ParaModel.submissionID = GUID();
    ParaModel.paraphrasers = [];
    // input = ' ' + input + ' ';

    await ParaModel.createSentenceFromInput(
      input,
      getState()?.pphr?.strength,
      getState()?.common?.platform?.isDesktop,
      getState()?.common?.platform?.isIE,
      getState()?.pphr?.wordFlipperValue
    );

    if (ParaModel.paraphrasers.length === 0) return false;
    dispatch(
      Actions.setInputSentences({
        inputId: GUID(),
        sentenceList: ParaModel.paraphrasers.map(({ pID, text, indent }) => ({
          pID,
          text,
          indent,
        })),
      })
    );
    // dispatch(setFocusedParaphraser(ParaModel.paraphrasers[0]));

    var paraphrasers = ParaModel.paraphrasers;
    var curP = 0;
    var finished = 0;
    var conti = () => {
      if (finished >= paraphrasers.length) {
        // Stats.updateStats();
        ParaModel.batchDispatchCall(dispatch, null);
        ParaModel.handleCompareModeCall(
          getState()?.common?.isOpencompareModeDrawer,
          getState()?.user?.premium
        );
        ParaModel.saveParaphraserData();

        if (ParaModel.paraphrasers.length >= 3) {
          if (QuillLocalStorage.getInstance().get('threebeamsOnboarding', 'false') === 'false') {
            QuillLocalStorage.getInstance().set('threebeamsOnboarding', 'true');
            dispatch(Actions.setSentenceControlToolBarState(false));
            dispatch(Actions.showPersistedSentenceControl(true));
          }
          dispatch(setFocusedParaphraser(ParaModel.paraphrasers[0]));
        }

        return;
      }
      var p = paraphrasers[curP];

      if (p) {
        curP += 1;
        p.paraphrase(
          {
            finished: () => {
              p.completed = true;
              finished += 1;
              dispatch(Actions.completedSentenceParaphrasing());
              conti();
            },
          },
          getState()?.pphr?.strength
        );
      }
    };

    var premium = getState()?.user?.premium;
    var amnt = premium ? (paraphrasers.length > 100 ? 10 : 15) : 2;
    for (var i = 0; i < amnt; i++) {
      conti();
    }
  };
